import { BulkCreateWizardFormAttachFlights, FilterState, FlightCandidateInfoType, FlightsStatusType } from './types';

export const BULK_CREATE_MAX_FLIGHTS_ALLOWED = 500;

export const BULK_CREATE_ATTACH_FLIGHTS_STEP_INITIAL_VALUES = {
  member: null,
  optimizationLevel: null,
  attachedFlights: [],
} as BulkCreateWizardFormAttachFlights;

export const INITIAL_FILTER_STATE: FilterState = {
  advertiser: [],
  flightDate: null,
  search: '',
};

export enum FilterOptionsActions {
  SET_SEARCH = 'SET_SEARCH',
  SET_ADVERTISER = 'SET_ADVERTISER',
  SET_FLIGHT_DATE = 'SET_FLIGHT_DATE',
  RESET_FILTERS = 'RESET_FILTERS',
}

export const initialFlightCandidateInfo: FlightCandidateInfoType = {
  loadingFlightCandidates: false,
  allMemberFlights: [],
  flightCandidates: [],
};

export const initialFlightsStatus: FlightsStatusType = {
  eligibleFlights: [],
  attachedToAnotherStrategy: [],
};

export enum CandidateTableDisplay {
  all = 'All',
  selected = 'Selected',
}

export enum FlightAlreadyAttachedSelection {
  include = 'include',
  exclude = 'exclude',
}

export const alreadyAttachedHeaderMessages = {
  default: 'Some objects are attached to existing strategies. You need to include them in selection if you wish to attach them to new strategies. Current strategies will be paused.',
  objectsIncludes: 'Some objects included in the selection are attached to existing strategies. Proceeding will pause active objects. Exclude from selection to avoid disrupting ongoing campaigns.',
};

export const attachedToAnotherStrategyTooltipMessages = {
  deafult: 'The object will not be included in the strategy creation.',
  included: 'The object will be detached from existing strategy and attach to the new one.',
};

export enum BulkUploadTabs {
  uploadFile = 'Upload File',
  inputId = 'Input ID',
}

export enum UploadOptions {
  replaceSelection = 'replaceSelection',
  addToSelection = 'addToSelection',
}

export const FILE_PARSE_ERROR = 'We\'re having trouble reading this file. Please try again later.';

export const configFileConfigBulkUploader = {
  'application/json': ['.json'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
};

export const BULK_UPLOAD_FILE_TEMPLATE_NAME = 'bulk_uploader_template.xlsx';
export const BULK_UPLOAD_FILE_TEMPLATE_PATH = `/templates/${BULK_UPLOAD_FILE_TEMPLATE_NAME}`;

export const MEMBER_ERROR = 'Please select a member to proceed.';
